const getSmallestDateBetweenTwo = (firstDate: Date, secondDate: Date) => {
  if (!firstDate || !secondDate) return

  return firstDate?.getTime() < secondDate?.getTime() ? firstDate : secondDate
}

export default getSmallestDateBetweenTwo
